import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Route-level guard that blocks navigation to sections not present in
 * the current user's `menuAccess` allow-list. If `menuAccess` is empty
 * or missing, all sections are allowed (back-compat).
 *
 * Keys MUST match the first path segment of the route AND the keys used
 * inside MENU_SECTIONS in UsersPage.jsx + Sidebar.jsx.
 */
const MenuGuard = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || !user) return children;
  const allowed = Array.isArray(user.menuAccess) ? user.menuAccess.map(String) : [];
  if (allowed.length === 0) return children;
  const seg = (location.pathname || '').split('/').filter(Boolean)[0] || '';
  // Always allow the panoramica fallback so we never get stuck in a redirect loop.
  if (seg === 'panoramica' || allowed.includes(seg)) return children;
  // Send the user to the first allowed section (or panoramica as last resort).
  const target = allowed[0] || 'panoramica';
  return <Navigate to={`/${target}`} replace />;
};

export default MenuGuard;
